import { request } from "../api";

export const getBwa = params => request.get("/reports/bwa", params);
export const getEuer = year => request.get("/reports/euer", { year });
export const getSusa = params => request.get("/reports/susa", params);
export const getLiquidity = scenario => request.post("/reports/liquidity", scenario);
export const listProjects = () => request.get("/reports/nachkalkulation/projects");
export const getNachkalkulation = (projectId, params) =>
  request.get(`/reports/nachkalkulation/${projectId}`, params);
export const getYearEnd = year => request.get("/reports/year-end", { year });
export const getOverview = () => request.get("/reports/overview");

export const downloadSusa = params => request.blob("/export/susa", params);
export const downloadDatevPackage = params => request.blob("/export/datev/package", params);
export const downloadBuchungsstapel = params =>
  request.blob("/export/datev/buchungsstapel", params);
export const downloadGobd = year => request.blob("/export/gobd", { year });

// Receivables reports (CB-4, RP-1..5, FA-4)
export const listStatementCustomers = q => request.get("/reports/customers", { q });
export const getStatement = (customerId, params) =>
  request.get(`/reports/customers/${customerId}/statement`, params);
export const downloadStatement = (customerId, params) =>
  request.blob(`/reports/customers/${customerId}/statement`, { ...params, format: "pdf" });
export const getBalanceConfirmation = (customerId, params) =>
  request.get(`/reports/customers/${customerId}/balance-confirmation`, params);
export const downloadBalanceConfirmation = (customerId, params) =>
  request.blob(`/reports/customers/${customerId}/balance-confirmation`, {
    ...params,
    format: "pdf"
  });
export const emailStatement = (customerId, body) =>
  request.post(`/reports/customers/${customerId}/statement/email`, body);
export const getCustomerPaymentBehaviour = (customerId, params) =>
  request.get(`/reports/customers/${customerId}/payment-behaviour`, params);
export const getDebitoren = params => request.get("/reports/debitoren", params);
export const downloadDebitoren = (params, format) =>
  request.blob("/reports/debitoren", { ...params, format });
export const getAusgangsbuch = params => request.get("/reports/ausgangsbuch", params);
export const downloadAusgangsbuch = (params, format) =>
  request.blob("/reports/ausgangsbuch", { ...params, format });
export const getCorrections = params => request.get("/reports/corrections", params);
export const downloadCorrections = params =>
  request.blob("/reports/corrections", { ...params, format: "csv" });
export const getPaymentBehaviour = params => request.get("/reports/payment-behaviour", params);
export const downloadPaymentBehaviour = params =>
  request.blob("/reports/payment-behaviour", { ...params, format: "csv" });
export const getAllowance = year => request.get("/reports/year-end/allowance", { year });
export const postAllowance = body => request.post("/reports/year-end/allowance", body);
